export const TABLE_UPDATE = "PRINT_PRINTS/TABLE_UPDATE";
export const FETCH_SUCCESS = "PRINT_PRINTS/FETCH_SUCCESS";

const types = {
    FETCH_FAILED: "PRINT_PRINTS/FETCH_FAILED",
    FETCH_REQUEST: "PRINT_PRINTS/FETCH_REQUEST",
    FETCH_SUCCESS,

    GET_FAILED: "PRINT_PRINTS/GET_FAILED",
    GET_REQUEST: "PRINT_PRINTS/GET_REQUEST",
    GET_SUCCESS: "PRINT_PRINTS/GET_SUCCESS",

    TABLE_UPDATE,
};

export default types;
